<template>
	<template v-if="isLoading()">
		<Loading />
	</template>
	<template v-else>
		<Slider :data="sliders" :rootImagePath="rootImagePath" />
		<Aboutus :data="aboutData" :rootImagePath="rootImagePath" />
		<Services :data="services" :rootImagePath="rootImagePath" />
		<Delivery :data="submitParcelLevels" :rootImagePath="rootImagePath" />
		<News :data="blogPosts" :rootImagePath="rootImagePath" />
		<Questions :data="faqs" :rootImagePath="rootImagePath" />
		<Contact :data="contactData" :rootImagePath="rootImagePath" />
		<Partner :data="partnertData" :rootImagePath="rootImagePath" />
	</template>
</template>

<script>
	import aboutData from "@/data/about.json";
	import contactData from "@/data/contact-us.json";
	import partnertData from "@/data/partner.json";
	import Slider from "./Slider.vue";
	import Aboutus from "./Aboutus.vue";
	import Services from "./Services.vue";
	import Delivery from "./Delivery.vue";
	import News from "./News.vue";
	import Questions from "./Questions.vue";
	import Partner from "./Partner.vue";
	import Contact from "./Contact.vue";
	import Loading from "../layout/aniresan/Loading.vue";
	export default {
		components: {
			Slider,
			Aboutus,
			Contact,
			Services,
			Delivery,
			News,
			Questions,
			Partner,
			Loading
		},
		data()
		{
			return {
				aboutData,
				contactData,
				partnertData,
				loading: true,
				rootImagePath: "",
				sliders: [],
				faqs: [],
				testimonials: [],
				services: [],
				blogPosts: [],
				siteSetting: {},
				server: this.$store.state.server,
				submitParcelLevels: [],
			};
		},
		beforeMount()
		{
			this.initHome();
		},
		methods: {

			isLoading()
			{
				return this.server.pendingRequests.length > 0;
			},

			initHome()
			{
				// if (db.select("homeData")) this.initData(db.select("homeData"));

				this.$server({
					method: "get",
					url: "/api/General/GetHomeData",
				})
					.then((response) =>
					{
						this.initData(response.data);
					})
					.catch((error) =>
					{
						console.log(error);
					});
			},

			initData(obj)
			{
				this.rootImagePath = obj.rootImagePath;
				this.sliders = obj.sliders;
				this.faqs = obj.faqs;
				this.submitParcelLevels = obj.submitParcelLevels;
				this.testimonials = obj.testimonials;
				this.services = obj.services;
				this.blogPosts = obj.blogPosts;
				this.siteSetting = obj.siteSetting;

				// db.insert("homeData", obj);
				this.loading = false;
			},
		},
	};
</script>
